module.exports = __webpack_public_path__ + "static/scale-model-of-clovis---big-dry-creek-museum-in-fresno-california-3a9003eac397f71287e011283032cfa3.png";